<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  icon?: string | boolean
  title?: string | null
  description?: string | null
}>()
</script>

<template>
  <div
    class="border-surface-200 bg-surface-50 flex flex-auto flex-col items-center justify-center gap-4 rounded-xl border border-dashed p-8 font-medium lg:p-12">
    <div v-if="icon">
      <i :class="icon" class="text-surface-400 !text-3xl" />
    </div>

    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      <div class="text-xl font-medium">{{ title || t('default.title') }}</div>
      <div class="text-center">
        {{ description || t('default.description') }}
      </div>
    </template>
    <template v-if="$slots.action">
      <div class="mt-8">
        <slot name="action" />
      </div>
    </template>
  </div>
</template>

<i18n>
{
    "de": {
        "default": {
            "title": "Keine Daten",
            "description": "Es sind keine Daten vorhanden."
        }
    },
    "en": {
        "default": {
            "title": "No data",
            "description": "No data available."
        }
    }
}
</i18n>
